import { useTenant } from '@rewardops/auth'
import type { Section } from '@rewardops/utils'

import AdButton from './adButton'
import ContentfulImage from './contentfulImage'

type Props = {
  content?: Section
}

function HalfWidthPane(props: Props) {
  const { content } = props

  if (!content) return <></>

  const { linkText, productUrl } = content

  return (
    <div className="col-span-2 m-2 overflow-y-hidden bg-cover bg-center p-10 text-black md:col-span-1">
      <div className="m-0 text-center">
        {content.headingImage ? (
          <ContentfulImage
            content={content.headingImage.image}
            label={'Ad logo'}
          />
        ) : undefined}
      </div>
      <div className="m-10 text-center">
        <div className="text-5xl font-semibold">{content.headingText}</div>
        <div className="mt-3 text-2xl font-normal">{content.content}</div>
        {linkText && productUrl ? (
          <AdButton
            href={productUrl}
            aria-label={`${linkText}: ${content.headingText}`}
          >
            {linkText}
          </AdButton>
        ) : undefined}
      </div>
      <ContentfulImage
        content={content.contentImages?.[0]?.image}
        label={content.headingText ?? 'Ad image'}
        className="h-auto w-auto"
        height="auto"
        width="auto"
        maxHeight="20rem"
      />
    </div>
  )
}

export default HalfWidthPane
